// Environment-dependent settings, resolved at run time.
//
// One image serves every environment: the container writes /config.js from its
// environment on start (docker/10-runtime-config.sh), and that file defines
// window.__ENV__. The VUE_APP_* values compiled in by Vue CLI are only a fallback,
// for `npm run serve`, Cypress and images built the old way.

const BUILD_TIME = {
  BACKEND_API_URL: process.env.VUE_APP_BACKEND_API_URL,
  PROTOCOL: process.env.VUE_APP_PROTOCOL,
  SHOW_SECRETS: process.env.VUE_APP_SHOW_SECRETS,
  SENTRY_DSN: process.env.VUE_APP_SENTRY_DSN,
  MIXPANEL_TOKEN: process.env.VUE_APP_MIXPANEL_TOKEN,
  LANDING_PAGE_URL: process.env.VUE_APP_LANDING_PAGE_URL,
  DOCUSEAL_URL: process.env.VUE_APP_DOCUSEAL_URL,
};

function runtime() {
  // eslint-disable-next-line no-underscore-dangle
  return (typeof window !== 'undefined' && window.__ENV__) || {};
}

/**
 * @param {keyof BUILD_TIME} name
 * @param {string|undefined} fallback returned when neither the runtime config nor the build defines the value
 */
export function env(name, fallback = undefined) {
  const value = runtime()[name];
  if (value !== undefined && value !== null && value !== '') {
    return value;
  }

  const buildTime = BUILD_TIME[name];
  return buildTime !== undefined && buildTime !== '' ? buildTime : fallback;
}

export function getShowSecretValue() {
  return /true/i.test(env('SHOW_SECRETS', ''));
}
